module.exports = __webpack_public_path__ + "static/media/Warning-Filled-blue.c84fc132.svg";